import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { Suspense } from 'react';

// Lazy‑load page components
const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ArticlesPage = lazy(() => import('../pages/articles/page'));
const ArticleDetailPage = lazy(() => import('../pages/article-detail/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PlayTherapyPage = lazy(() => import('../pages/play-therapy/page'));
const FamilyTherapyPage = lazy(() => import('../pages/family-therapy/page'));
const DotTherapyPage = lazy(() => import('../pages/dot-therapy/page'));
const TeenCounselingPage = lazy(() => import('../pages/teen-counseling/page'));
const ParentCounselingPage = lazy(() => import('../pages/parent-counseling/page'));
const ChildCounselingPage = lazy(() => import('../pages/child-counseling/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
import ScreenAddictionPage from "../pages/screen-addiction/page";

const PrivacyPage = lazy(() => import("../pages/privacy/page"));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/hakkimda',
    element: <AboutPage />,
  },
  {
    path: '/hizmetler',
    element: <ServicesPage />,
  },
  {
    path: '/makaleler',
    element: <ArticlesPage />,
  },
  {
    path: '/makale/:id',
    element: <ArticleDetailPage />,
  },
  {
    path: '/iletisim',
    element: <ContactPage />,
  },
  {
    path: '/oyun-terapisi',
    element: <PlayTherapyPage />,
  },
  {
    path: '/aile-terapisi',
    element: <FamilyTherapyPage />,
  },
  {
    path: '/deneyimsel-oyun-terapisi',
    element: <DotTherapyPage />,
  },
  {
    path: '/ergen-danismanligi',
    element: <TeenCounselingPage />,
  },
  {
    path: '/ebeveyn-danismanligi',
    element: <ParentCounselingPage />,
  },
  {
    path: '/cocuk-danismanligi',
    element: <ChildCounselingPage />,
  },
  {
    path: '/ekran-bagimliligi',
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <ScreenAddictionPage />
      </Suspense>
    ),
  },
  {
    path: '/gizlilik-etik',
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <PrivacyPage />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
